import {
    createSlice,
    PayloadAction,
} from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getWorkTimeTypes,
    getSalaryRowTypes,
} from "../services/workTimeBetaService";
import { WorkTimeType } from "../models/workShitTimeSlot/workTimeType";
import { ISalaryRowType } from "../models/workShitTimeSlot/salaryRowType";

interface WorkShiftTimeSlotState {
    selectedId: string;
    workTimeTypes: WorkTimeType[];
    salaryRowTypes: ISalaryRowType[];
}

const initialState: WorkShiftTimeSlotState = {
    selectedId: null,
    workTimeTypes: null,
    salaryRowTypes: null,
};

export const workShiftTimeSlotSlice = createSlice({
    name: "workShiftTimeSlot",
    initialState,
    reducers: {
        toggleSelectedId: (state, action: PayloadAction<string>) => {
            state.selectedId =
                action.payload === state.selectedId ? null : action.payload;
        },
        setWorkTimeTypes: (state, action: PayloadAction<WorkTimeType[]>) => {
            state.workTimeTypes = action.payload;
        },
        setSalaryRowTypes: (state, action: PayloadAction<ISalaryRowType[]>) => {
            state.salaryRowTypes = action.payload;
        },
    },
});

export const {
    toggleSelectedId,
    setWorkTimeTypes,
    setSalaryRowTypes,
} = workShiftTimeSlotSlice.actions;

export const fetchWorkTimeTypes = createAsyncThunk(
    "workShiftTimeSlot/workTimeTypes",
    async(_, thunkApi) => {
        const workTimeTypes = await getWorkTimeTypes(thunkApi.signal);
        thunkApi.dispatch(setWorkTimeTypes(workTimeTypes));
    }
);

export const fetchSalaryRowTypes = createAsyncThunk(
    "workShiftTimeSlot/salaryRowTypes",
    async(_, thunkApi) => {
        const salaryRowTypes = await getSalaryRowTypes();
        thunkApi.dispatch(setSalaryRowTypes(salaryRowTypes));
    }
);

export const workShiftTimeSlotReducer = workShiftTimeSlotSlice.reducer;

export const selectWorkTimeTypes = (state: { workShiftTimeSlot: WorkShiftTimeSlotState }): WorkTimeType[] => state.workShiftTimeSlot.workTimeTypes;
export const selectSalaryRowTypes = (state: { workShiftTimeSlot: WorkShiftTimeSlotState }): ISalaryRowType[] => state.workShiftTimeSlot.salaryRowTypes;
